module.exports = __webpack_public_path__ + "img/appBarMovile.ba0dc916.png";